// Enum mapping for solve_type values from API
export const SOLVE_TYPE_ENUM = {
  ACCUMULATION: 1,
  INCOME: 2,
  CONTRIBUTION: 3,
  GMB_INCOME: 4
};

// Reverse mapping: number to string
export const SOLVE_TYPE_MAP = {
  1: 'Accumulation',
  2: 'Income',
  3: 'Contribution',
  4: 'GMBIncome'
};

// Annuity-specific product type mapping
export const annuityProductTypeMap = {
  FA: 'Fixed Annuity',
  FIA: 'Fixed Indexed Annuity',
  MYGA: 'Multi-Year Guaranteed Annuity'
};

// Helper function to convert enum array to string array
export const mapSolveTypeEnumToStrings = enumArray => {
  if (!Array.isArray(enumArray) || enumArray.length === 0) {
    return null;
  }

  return enumArray.map(enumValue => SOLVE_TYPE_MAP[enumValue]).filter(Boolean);
};

// Helper function to convert string to enum
export const mapSolveTypeStringToEnum = solveTypeString => {
  const enumEntry = Object.entries(SOLVE_TYPE_MAP).find(([_, value]) => value === solveTypeString);
  return enumEntry ? parseInt(enumEntry[0], 10) : null;
};
